"use client";

import { Button } from "@/components/buttons/Button";
import { Modal } from "@/components/Modal";
import { NormalText } from "@/components/text/NormalText";
import { planChangeModalFalseAction } from "@/data/auth/actions/planChangeModalFalseAction";
import { UserNoDates } from "@/types/types";
import { getSubscriptionPlan } from "@/utils/subscriptionLevels/getSubscriptionPlan";
import { getFormattedTimeLeft } from "@/utils/time/getFormattedTimeLeft";

export function PlanChangeModal({ user }: { user: UserNoDates }) {
  const subscriptionPlan = getSubscriptionPlan(user.stripeSubscriptionId);

  let showModal = false;
  if (user.showPlanChangeModal) {
    // Only show the modal if the user has the first or second plan. To cover the case where the user got the show modal flag but since had their subscription cancelled.
    if (subscriptionPlan === "first" || subscriptionPlan === "second") {
      showModal = true;
    }
  }

  const handleCloseModal = async () => {
    await planChangeModalFalseAction();
  };

  return (
    <Modal
      open={showModal}
      closeModal={handleCloseModal}
      title="Rollover 🎉"
      widthMode="normal"
    >
      <NormalText elementType="p" className="mb-4">
        Starting now, any unused conversion time will roll over to the next
        month. You don't need to do anything for this to take effect.
      </NormalText>

      {/* Middle text for first plan */}
      {subscriptionPlan === "first" && (
        <NormalText elementType="p">
          To celebrate, we've added an extra hour of conversion time to your
          account.
        </NormalText>
      )}

      {/* Middle text for second plan */}
      {subscriptionPlan === "second" && (
        <NormalText elementType="p">
          Going forward, the Pro plan will be refilled with 3 hours of
          conversion time every month. To show our appreciation for you as an
          early user, we've added 20 hours of conversion time to your account.
        </NormalText>
      )}

      {/* user.conversionTimeLeftSeconds should never be null here */}
      {user.conversionTimeLeftSeconds !== null && (
        <div className="mt-6 flex justify-between gap-x-4 rounded-3xl bg-white px-4 py-2 shadow-sm ring-1 ring-gray-900/5">
          <NormalText elementType="p">New total conversion time:</NormalText>

          <NormalText elementType="p">
            {getFormattedTimeLeft(user.conversionTimeLeftSeconds)}
          </NormalText>
        </div>
      )}

      <Button onClick={handleCloseModal} className="ml-auto mt-6 block">
        Continue
      </Button>
    </Modal>
  );
}
